export interface ExchangeData {
  customerId?: number;
  amount: string;
  confirmation: string;
  ticketNum: string;
  registeredBy: string;
}

export const emptyExchangeData: ExchangeData = {
  amount: "",
  confirmation: "",
  ticketNum: "",
  registeredBy: "admin",
};
